import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useStore, useRoute, ref } from '@nuxtjs/composition-api';
import LinkSmallMegaMenu from './LinkSmallMegaMenu.vue';
import megaMenuLinks from '~/data/mega_menu_links';
import { useUser } from '~/composables/useUser';
import TLinkButton from '~/components/atoms/t-link-button.vue';
import TButton from '~/components/atoms/t-button.vue';
import TAccordion from '~/components/atoms/t-accordion.vue';
import DownloadsPill from '~/components/atoms/DownloadsPill.vue';
import { usePlusDownloads } from '~/composables/usePlusDownloads';
import { useTwoRowHeader } from '~/composables/useTwoRowHeader';
import { State } from '~/store';
import { useLocale } from '~/composables/useLocale';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmallMegaMenu',
  setup(__props) {

const store = useStore<State>();
const route = useRoute();
const { i18n, $config, $isFlagOn, $getExperimentVariant } = useContext();
const locale = useLocale();
const { linkClickedEvent, openNavEvent } = useTwoRowHeader();

const { user } = useUser();

const { doesUserGetPlusDownloads, plusDownloadsLeft } = usePlusDownloads();

const isFreeUser = computed(() => user.value?.subscription?.code === 'free');
const isNonPlusMember = computed(() => user.value?.subscription?.code !== 'teach_plus');

const toggleLocationSelectorModal = (show: Boolean) => {
  store.dispatch('toggleLocationSelectorModal', show);
};
const location = computed(() => store.state.location);
const trendingTopics = computed(() => store.getters.trendingTopics?.slice(0, 4));
const isPlusLiteMember = computed(() => user.value?.subscription?.code === 'plus_lite');

const error = ref<any>(null);

const logout = async () => {
  try {
    await store.dispatch('logout');
    await store.dispatch('dismissToast');
    await store.dispatch('toggleMobileNav', false);
  } catch (e) {
    error.value = e;
  }
};

const getPlanName = computed(() => {
  if (!user.value) {
    return '';
  }
  return user.value.subscription && user.value.subscription.code !== 'free'
    ? user.value.subscription.name
    : user.value.role.replace(/_/g, ' ');
});
const isSchoolMember = computed(
  () =>
    user.value?.subscription?.code === 'school_ultimate' ||
    user.value?.subscription?.code === 'school_plan' ||
    user.value?.subscription?.code === 'school_plan_member' ||
    user.value?.subscription?.code === 'school_plan_admin_only'
);

return { __sfc: true,store, route, i18n, $config, $isFlagOn, $getExperimentVariant, locale, linkClickedEvent, openNavEvent, user, doesUserGetPlusDownloads, plusDownloadsLeft, isFreeUser, isNonPlusMember, toggleLocationSelectorModal, location, trendingTopics, isPlusLiteMember, error, logout, getPlanName, isSchoolMember, LinkSmallMegaMenu, megaMenuLinks, TLinkButton, TButton, TAccordion, DownloadsPill }
}

})